import React from "react";
import { SlidersHorizontal, X } from "lucide-react";
import SidebarNavIcon from "../../app/components/ui/SidebarNavIcon";

export function AdminFilterSection({ label, labelIcon: LabelIcon, children }) {
  return (
    <section className="am-nav-section">
      <p className="am-nav-section-label">
        {LabelIcon ? <LabelIcon size={10} strokeWidth={2.4} aria-hidden /> : null}
        {label}
      </p>
      <div className="am-nav-list">{children}</div>
    </section>
  );
}

export function AdminNavFilterItem({
  active,
  onClick,
  icon,
  label,
  hint,
  count,
  countTone,
  urgent,
  disabled,
}) {
  return (
    <button
      type="button"
      className={`am-nav-item${active ? " am-nav-item-on" : ""}${
        urgent && !active ? " am-nav-item-urgent" : ""
      }${disabled ? " am-nav-item-disabled" : ""}`}
      aria-pressed={active}
      disabled={disabled}
      onClick={onClick}
    >
      <span className="am-nav-item-bar" aria-hidden />
      <span className="am-nav-item-icon">
        <SidebarNavIcon icon={icon} size={13} />
      </span>
      <span className="am-nav-item-copy">
        <strong>{label}</strong>
        {hint ? <em className="tabular-nums">{hint}</em> : null}
      </span>
      {count != null && count > 0 ? (
        <span className={`am-nav-item-count${countTone ? ` am-nav-item-count-${countTone}` : ""}`}>
          {count}
        </span>
      ) : null}
    </button>
  );
}

export default function AdminFiltersRail({
  title,
  subtitle,
  deskIcon: DeskIcon,
  compact,
  onClose,
  activeCount = 0,
  onClear,
  summaryCount,
  summaryCopy,
  children,
}) {
  const hasFilters = activeCount > 0;
  const showSummary = summaryCount != null || summaryCopy;

  return (
    <aside className={`am-nav-rail${compact ? " am-nav-rail-compact" : ""}`}>
      <div className="am-nav-head">
        <div className="am-nav-brand">
          {DeskIcon ? (
            <span className="am-nav-brand-mark">
              <DeskIcon size={13} strokeWidth={2.3} aria-hidden />
            </span>
          ) : null}
          <span className="am-nav-brand-copy">
            <span className="am-nav-brand-label">{title}</span>
            {subtitle ? <span className="am-nav-brand-sub">{subtitle}</span> : null}
          </span>
        </div>
        {compact && onClose ? (
          <button
            type="button"
            className="am-nav-close"
            onClick={onClose}
            aria-label="Close filters"
          >
            <X size={14} />
          </button>
        ) : (
          <span className="am-nav-head-glyph" aria-hidden>
            <SlidersHorizontal size={12} strokeWidth={2.25} />
          </span>
        )}
      </div>

      {showSummary ? (
        <div className="am-nav-summary" aria-live="polite">
          {summaryCount != null ? (
            <span className="am-nav-summary-count tabular-nums">{summaryCount}</span>
          ) : null}
          {summaryCopy ? <span className="am-nav-summary-copy">{summaryCopy}</span> : null}
        </div>
      ) : null}

      <div className="am-nav-scroll">{children}</div>

      {hasFilters && onClear ? (
        <button type="button" className="am-nav-clear" onClick={onClear}>
          Clear {activeCount} filter{activeCount === 1 ? "" : "s"}
        </button>
      ) : null}
    </aside>
  );
}
